export class AuthTools {

    constructor() {

    }

    hasJwt() {
        const jwt = !!window.localStorage.getItem("appToken");
        return jwt;
    }

}